import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0970E6",
      "fill-rule": "evenodd",
      d: "M12.504 2.499a1.5 1.5 0 0 1 1.5-1.5H18.1a1.5 1.5 0 0 1 1.5 1.5v1.125c0 .254-.063.493-.174.702.296.822.637 2.297.916 3.836.31 1.711.56 3.612.588 4.971a.75.75 0 0 1-1.5.03c-.024-1.24-.26-3.05-.565-4.734-.245-1.356-.523-2.561-.749-3.29h-3.924c-.804 2.053-1.922 6.9-1.377 12.948.01.11.105.206.236.206h1.315a.75.75 0 0 1 0 1.5h-1.315a1.73 1.73 0 0 1-1.73-1.571q-.052-.585-.086-1.156c-.595.871-1.44 1.805-2.573 2.533a.95.95 0 0 1-.512.145H4.266a.95.95 0 0 1-.512-.145C1.511 18.159.398 15.912.118 14.94a4.39 4.39 0 0 1 1.136-4.07 4.4 4.4 0 0 1 4.048-1.23l.392.09c.03-.473-.218-.797-.469-1.125q-.065-.084-.127-.169a.75.75 0 1 1 1.21-.885q.026.035.073.091.07.084.167.214.183-.366.47-.716c.751-.91 2-1.59 3.914-1.665a.75.75 0 0 1 .767.613c.151.818.088 2.046-.656 3.023-.277.364-.63.67-1.06.9a4.4 4.4 0 0 1 1.385 1.083c.306-2.926.919-5.22 1.448-6.555a1.5 1.5 0 0 1-.312-.916zm1.5 0H18.1v1.125h-4.097zM9.85 8.204c-.309.405-.914.815-2.144.793.08-.288.226-.607.469-.901.36-.438.986-.88 2.083-1.052-.03.404-.153.825-.408 1.16M6.462 11.33l.973-.225a2.9 2.9 0 0 1 2.656.814 2.89 2.89 0 0 1 .757 2.64c-.218.713-1.106 2.499-2.855 3.684H4.425c-1.75-1.185-2.638-2.971-2.856-3.683a2.89 2.89 0 0 1 .757-2.641 2.9 2.9 0 0 1 2.656-.814l.973.225z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0970E6",
      d: "M16.086 19.05a.75.75 0 0 1 .75-.75h2.455v-2.45a.75.75 0 0 1 1.5 0v2.45h2.457a.75.75 0 0 1 0 1.5h-2.457v2.452a.75.75 0 0 1-1.5 0V19.8h-2.455a.75.75 0 0 1-.75-.75"
    }, null, -1)
  ]))]))
}
export default { render: render }